import React, { useState, useEffect } from "react";
import client from "../sanity";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import LoaderButton from "./LoaderButton";
import { loading } from "../assets/Infinity-1s-200px.gif";

const useStyles = makeStyles((theme) => ({
  modalButton: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    justifyContent: "center",
  },
}));

export default function TriviaModal(props) {
  const [trivia, setTrivia] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    try {
      const facts = await client.fetch(` *[_type == 'trivia']`);
      const randomFact = Math.floor(Math.random() * facts.length);
      setTrivia(facts[randomFact]);
      console.log(facts);
      console.log(randomFact);
      console.log({ loading });
    } catch (e) {
      if (e !== "Aw no fun facts):") {
        alert(e);
      }
    }
  }
  const handleClose = () => {
    setOpen(false);
    console.log("hello");
  };
  return (
    <div style={{ overflow: "visible", textAlign: "center", paddingTop: 25 }}>
      <Card className={classes.root}>
        <img
          src={require("../assets/Infinity-1s-200px.gif")}
          alt="loading..."
        />

        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {trivia.trivia}
          </Typography>
          <Typography variant="h5" component="h2">
            {trivia.description}
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            {trivia.author}
          </Typography>
          <Typography variant="body2" component="p">
            {trivia.link}
          </Typography>
        </CardContent>
        <div className={classes.modalButton}>
          <LoaderButton
            style={{
              backgroundColor: "#00303F",
              display: "flex",
              flex: "center",
            }}
            onClick={props.handleClose}
          >
            close
          </LoaderButton>
        </div>
      </Card>
    </div>
  );
}
